import React from 'react';

const stop = (e) => e.preventDefault();

export default function MatchHeader({ match, scorecardOpen, onToggleScorecard }) {
  return (
    <div className="card-header game-heading">
      <span className="card-header-title">{match.title}</span>
      <span className="date-time"> {match.datetime}
        <div>
          <a href="#!" className="best_link d-lg-none" onClick={stop}>Bets</a>
          <a
            href="#!"
            role="button"
            aria-expanded={!!scorecardOpen}
            className="scorecard-icon"
            title="Scorecard"
            onClick={(e) => { stop(e); if (onToggleScorecard) onToggleScorecard(); }}
          >
            <i className="bi bi-clipboard-data" />
          </a>
        </div>
      </span>
    </div>
  );
}
